import { render, staticRenderFns } from "./AppValidatorAlerts.vue?vue&type=template&id=1b5397c7&"
import script from "./AppValidatorAlerts.vue?vue&type=script&lang=js&"
export * from "./AppValidatorAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports